const React = require('react');
const { useLiveDemoContext } = require('./Provider/liveDemoContext');

const View = ({ componentDemo: ComponentDemo, i18n, lang, isLoggedAccountATestUser, brand, children }) => {
  const { formData } = useLiveDemoContext();

  return (
    <div
      className={`live-demo-view-container ${formData.resolution === 'mobile' && 'live-demo-view-container--mobile-res'}`}
    >
      <ComponentDemo {...formData} i18n={i18n} lang={lang} isLoggedAccountATestUser={isLoggedAccountATestUser} brand={brand} />
      {children}
    </div>
  );
};

module.exports = View;
